import { Injectable } from '@angular/core'

import { Observable } from 'rxjs'
import { environment } from '@env/environment'
import { ApiService } from '@app/core/_services/api.service'
import { map } from 'rxjs/operators'
import { AnalyticsService } from './analytics.service'
import { AuthService } from './auth.service'

@Injectable()
export class DeleteAccountService {
    constructor(
        private apiService: ApiService,
        private analyticsService: AnalyticsService,
        private authService: AuthService,
    ) {}

    deleteAccount(): Observable<any> {
        return this.apiService.delete(environment.api_url + 'account/', {}).pipe(
            map((data) => {
                this.analyticsService.logAccountDelete(false)
                this.authService.signOut('deleteAccount')
            }),
        )
    }

    ngOnDestroy() {}
}
